import Api from "common/Api";
import {
    AlertApiError,
    LoadingOverlayIndicator,
    SpreadPublicationMetaData,
    TemplateGeneralInformation,
    TemplatePrintingPriceCalculator
} from "components";
import React, {useState} from "react";
import {Accordion, Button, Col, Form, Image, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const SpreadPublicationInfo = ({spreadPublicationData}) => {
    const {t} = useTranslation();

    const [isCreatingPublication, setIsCreatingPublication] = useState(false);
    const [canCreatePublication, setCanCreatePublication] = useState(true);
    const [publicationCreateSpecification, setPublicationCreateSpecification] = useState(
        {
            spreadPublicationId: spreadPublicationData.spreadPublicationId,
            publicationName: spreadPublicationData.publicationName
        }
    );

    const [apiError, setApiError] = useState(null);

    const templatePrintPrice = {
        printingPriceLink: spreadPublicationData.printingPriceLink,
        rootContainerSectionPageCountMin: spreadPublicationData.rootContainerSectionPageCountMin,
        rootContainerSectionPageCountMax: spreadPublicationData.rootContainerSectionPageCountMax
    }

    const spreadPublicationMetaData = {
        publicationName: spreadPublicationData.publicationName
    }

    const _createPublication = () => {
        if (spreadPublicationData.publicationCreateLink && canCreatePublication) {
            setIsCreatingPublication(true);
            Api.post(spreadPublicationData.publicationCreateLink, publicationCreateSpecification)
                .then(publicationRepresentationModel => {
                    window.location.href = publicationRepresentationModel.getHref('edit-publication');
                    setTimeout(() => {
                        setIsCreatingPublication(false);
                    }, 2000);
                })
                .catch(apiError => {
                    setApiError(apiError);
                    setIsCreatingPublication(false);
                });
        }
    }

    const _onSpreadPublicationMetaDataChange = (metaData) => {
        setCanCreatePublication(!metaData.hasError);
        setPublicationCreateSpecification(prevState => ({
            ...prevState,
            publicationName: metaData.form.publicationName
        }));
    };

    return (
        <>
            {apiError &&
                <AlertApiError apiError={apiError}/>
            }

            <LoadingOverlayIndicator
                show={isCreatingPublication}
                message={t('GeCreatePublicationWizard.creating.process')}
            />

            <Row className={"template-info px-4 py-4 gap-4"}>
                <Col xs={12}>
                    <Form onSubmit={event => event.preventDefault()}>
                        <Row className={"g-5"}>
                            <Col xs={12} md={12} lg={4}>
                                <p className={"thumbnail-wrapper img-thumbnail"}>
                                    <Image
                                        fluid
                                        className={"image-shadow"}
                                        src={spreadPublicationData.publicationThumbnailLink?.getLinkPath()}
                                    />
                                </p>
                                {spreadPublicationData.bestPracticePdfLink?.getHref() &&
                                    <p>
                                        <a href={spreadPublicationData.bestPracticePdfLink.getHref()}>
                                            <i className={"fal fa-lg fa-fw fa-download"}/>&nbsp;
                                            {t('template.details.open.best.practice.pdf')}
                                        </a>
                                    </p>
                                }
                            </Col>
                            <Col xs={12} md={12} lg={5} className={"form-col"}>
                                <p>{spreadPublicationData.description}</p>
                                <SpreadPublicationMetaData
                                    spreadPublicationMetaData={spreadPublicationMetaData}
                                    onSpreadPublicationMetaDataChange={_onSpreadPublicationMetaDataChange}
                                />
                            </Col>
                            <Col xs={12} md={12} lg={3}>
                                <p className={"text-end"}>
                                    <Button
                                        variant={"primary"}
                                        size={"lg"}
                                        className={"create-publication"}
                                        disabled={isCreatingPublication || !canCreatePublication}
                                        onClick={() => _createPublication()}
                                    >
                                        {t('spread.publication.details.create.publication.button.label')}
                                    </Button>
                                </p>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xs={12}>
                    <Accordion id={"accordionTemplateDetails"} alwaysOpen={true} defaultActiveKey={['0']}>
                        <TemplateGeneralInformation
                            accordionEventKey={"0"}
                            templateDescription={spreadPublicationData.description}
                            productDetails={spreadPublicationData.productDetails}
                        />
                        {templatePrintPrice.printingPriceLink &&
                            <TemplatePrintingPriceCalculator
                                accordionEventKey={"1"}
                                templatePrintPrice={templatePrintPrice}
                            />
                        }
                    </Accordion>
                </Col>
            </Row>
        </>
    );
};

export default SpreadPublicationInfo;